export default "__VITE_ASSET__DVlOPhxu__"